import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {SwitchRecordingModeEvent} from '../../../pages/inputs/interfaces/switch-recording-mode.event.interface';
import {DvrRecordStatus} from '../../../services/api/dvr/dvr.model';
import {UUID} from '../../types/uuid.type';
import {DataSourceStreamDvrRecord} from '../../../store/stream-configurations/data-source/stream-configurations.data-source.selector';

@Component({
  selector: 'app-switch-recording-btn',
  templateUrl: './switch-recording-btn.component.html',
  styleUrls: ['./switch-recording-btn.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SwitchRecordingBtnComponent implements OnChanges {
  @Input() record: DataSourceStreamDvrRecord;

  @Output() createRecord: EventEmitter<void> = new EventEmitter<void>();
  @Output() switchRecordingModeEvent: EventEmitter<SwitchRecordingModeEvent> = new EventEmitter<SwitchRecordingModeEvent>();

  public status: DvrRecordStatus = 'completed';
  public startedAt: number = Date.now();

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.record) {
      if (this.record) {
        this.status = this.record.status;
        this.startedAt = this.record.startedAt || null;
      }

      if (!this.record) {
        this.status = 'completed';
        this.startedAt = Date.now();
      }
    }
  }

  public onSwitchRecordingMode(): void {
    if (!this.record) {
      this.switchRecordingModeEvent.emit({mode: 'start', recordId: null});
      return;
    }

    const recordId: UUID = this.record.id;
    const status: DvrRecordStatus = this.record.status;
    switch (status) {
      case 'recording':
      case 'starting':
        this.switchRecordingModeEvent.emit({mode: 'stop', recordId});
        break;
      case 'completed':
      case 'failed':
        this.switchRecordingModeEvent.emit({mode: 'start', recordId});
        break;
      case 'waiting':
        this.switchRecordingModeEvent.emit({mode: 'delete', recordId});
        break;
      default:
        console.error('Unknown status: ' + this.status);
    }
  }

}
